import React from 'react';
import { useI18n } from '../i18n.js';
import { Icon } from './Icon.js';

export interface ActiveMatchInfo {
  roomId: string;
  gameType?: string;
  playerName?: string;
  timestamp: number;
}

interface ActiveMatchBannerProps {
  match: ActiveMatchInfo;
  onRejoin: () => void;
  onDismiss: () => void;
}

export const ActiveMatchBanner: React.FC<ActiveMatchBannerProps> = ({
  match,
  onRejoin,
  onDismiss,
}) => {
  const { lang, t } = useI18n();
  const isMn = lang === 'mn';

  const gameLabel =
    match.gameType === 'muushig'
      ? isMn
        ? 'Муушиг'
        : 'Muushig'
      : match.gameType === 'twentyone'
      ? '21'
      : match.gameType === 'daaluu'
      ? isMn
        ? 'Даалуу'
        : 'Daaluu'
      : isMn
      ? 'Арван гурав'
      : 'Big Two';

  return (
    <aside
      className="active-match-banner"
      role="alert"
      aria-label={t.matchInProgress}
    >
      <div className="active-match-body">
        <div className="active-match-pulse" aria-hidden="true" />
        <div className="active-match-text">
          <span className="active-match-eyebrow">
            ⚡ {t.matchInProgress} · {gameLabel}
          </span>
          <p className="active-match-desc">
            {t.matchInProgressDesc(match.roomId)}
          </p>
        </div>
      </div>
      <div className="active-match-actions">
        <button
          type="button"
          className="active-match-rejoin-btn"
          onClick={onRejoin}
          title={t.rejoinMatch}
        >
          <Icon name="rotate-ccw" size={14} />
          <span>{t.rejoinMatch}</span>
        </button>
        <button
          type="button"
          className="active-match-dismiss-btn"
          onClick={onDismiss}
          title={t.abandonMatch}
          aria-label={t.abandonMatch}
        >
          <span>{t.abandonMatch}</span>
        </button>
      </div>
    </aside>
  );
};
